import {Injectable} from '@angular/core';
import {Person} from "../interfaces/person";
import {BehaviorSubject} from "rxjs";
import Organization from "../interfaces/organization";
import Sponsor from "../interfaces/sponsor";
import {ContactCategory} from "./contacts-list.component";
import {Apollo} from "apollo-angular";
import {
  get_organization,
  get_orgs_contacts,
  get_people_contacts,
  get_person,
  get_sponsor, get_sponsor_organization_deals,
  get_sponsors
} from "./graphql/getContacts";
import OwnershipInterest from "../interfaces/ownership-interest";
import {
  FundInvestment
} from "./contacts-subcomponents/contacts-fund-investors-table/contacts-fund-investors-table.component";
import {ContactDealTable} from "./contacts-subcomponents/contact-deals-table/contact-deals-table.component";
import Participant from "../interfaces/participant";
import {DataFormatService} from "../services/data-format.service";
import ProjectAttribute from "../interfaces/project-attribute";
import ProjectCredit from "../interfaces/project-credit";
import PricePerCredit from "../interfaces/price-per-credit";
import {ContactsOutletsTable} from "./contacts-subcomponents/contacts-outlets-table/contacts-outlets-table.component";
import {CurrencyPipe, DatePipe} from "@angular/common";
import Project from "../interfaces/project";
import {PageEvent} from "@angular/material/paginator";
import ProjectCreditOutlet from "../interfaces/project-credit-outlet";

@Injectable({
  providedIn: 'root'
})
export class ContactsService {

  constructor(private apollo: Apollo, private dataFormat: DataFormatService, private currencyPipe: CurrencyPipe, private datePipe: DatePipe) { }

  private _listPageData:any = {}
  private listPageData = new BehaviorSubject(this._listPageData)
  public listPageData$ = this.listPageData.asObservable();

  private _projectPageData:any = {}
  private projectPageData = new BehaviorSubject(this._projectPageData)
  public projectPageData$ = this.projectPageData.asObservable();

  private _deadProjectPageData:any = {}
  private deadProjectPageData = new BehaviorSubject(this._deadProjectPageData)
  public deadProjectPageData$ = this.deadProjectPageData.asObservable();

  private _sponsorProjectPageData:any = {}
  private sponsorProjectPageData = new BehaviorSubject(this._sponsorProjectPageData)
  public sponsorProjectPageData$ = this.sponsorProjectPageData.asObservable();

  private _deadSponsorProjectPageData:any = {}
  private deadSponsorProjectPageData = new BehaviorSubject(this._deadSponsorProjectPageData)
  public deadSponsorProjectPageData$ = this.deadSponsorProjectPageData.asObservable();

  private _loading:boolean = true;
  private loading = new BehaviorSubject(this._loading)
  public loading$ = this.loading.asObservable();

  private _sponsorTableLoading: boolean = true;
  private sponsorTableLoading = new BehaviorSubject(this._sponsorTableLoading)
  public sponsorTableLoading$ = this.sponsorTableLoading.asObservable();

  private _people:Person[] = []
  private people = new BehaviorSubject(this._people)
  public people$ = this.people.asObservable()

  private _organizations:Organization[] = []
  private organizations = new BehaviorSubject(this._organizations)
  public organizations$ = this.organizations.asObservable();

  private _sponsors:Sponsor[] = []
  private sponsors = new BehaviorSubject(this._sponsors)
  public sponsors$ = this.sponsors.asObservable();

  private _person: Person | null = null;
  private person = new BehaviorSubject(this._person)
  public person$ = this.person.asObservable()

  private _organization: Organization | null = null
  private organization = new BehaviorSubject(this._organization)
  public organization$ = this.organization.asObservable();

  private _fundInvestments: FundInvestment[] = []
  private fundInvestments = new BehaviorSubject(this._fundInvestments)
  public fundInvestments$ = this.fundInvestments.asObservable();

  private _associatedDeals: ContactDealTable[] = []
  private associatedDeals = new BehaviorSubject(this._associatedDeals)
  public associatedDeals$ = this.associatedDeals.asObservable();

  private _deadDeals: ContactDealTable[]  = []
  private deadDeals = new BehaviorSubject(this._deadDeals)
  public deadDeals$ = this.deadDeals.asObservable()

  private _sponsorDeals: ContactDealTable[] = []
  private sponsorDeals = new BehaviorSubject(this._sponsorDeals)
  public sponsorDeals$ = this.sponsorDeals.asObservable();

  private _deadSponsorDeals: ContactDealTable[] = []
  private deadSponsorDeals = new BehaviorSubject(this._deadSponsorDeals)
  public deadSponsorDeals$ = this.deadSponsorDeals.asObservable();

  private _outlets: ContactsOutletsTable[] = []
  private outlets = new BehaviorSubject(this._outlets)
  public outlets$ = this.outlets.asObservable();

  private _sponsor: Sponsor | null = null
  private sponsor = new BehaviorSubject(this._sponsor)
  public sponsor$ = this.sponsor.asObservable()

  private _sponsorOrgs: Organization[] = []
  private sponsorOrgs = new BehaviorSubject(this._sponsorOrgs)
  public sponsorOrgs$ = this.sponsorOrgs.asObservable()

  private _companyEvents:any[] = []
  private companyEvents = new BehaviorSubject(this._companyEvents)
  public companyEvents$ = this.companyEvents.asObservable()

  private _totals:any = {}
  private totals = new BehaviorSubject(this._totals)
  public totals$ = this.totals.asObservable()

  private _deadTotals:any = {}
  private deadTotals = new BehaviorSubject(this._deadTotals)
  public deadTotals$ = this.deadTotals.asObservable()

  private _sponsorOrgTotals:any = {}
  private sponsorOrgTotals = new BehaviorSubject(this._sponsorOrgTotals)
  public sponsorOrgTotals$ = this.sponsorOrgTotals.asObservable();

  private _deadOrgTotals:any = {}
  private deadOrgTotals = new BehaviorSubject(this._deadOrgTotals)
  public deadOrgTotals$ = this.deadOrgTotals.asObservable();


  private _setListPagination(data:any){
    if(data.getPeople){
      this._listPageData = data.getPeople.paginatorInfo
    }
    if(data.getOrganizations){
      this._listPageData = data.getOrganizations.paginatorInfo
    }
    if(data.getSponsors){
      this._listPageData = data.getSponsors.paginatorInfo
    }
    this.listPageData.next(this._listPageData)
  }

  private _setProjectTablePagination(data: any){
    if(data.projects){
      let pageData = {...data.projects.paginatorInfo}
      let deadPageData = {...data.deadDeals.paginatorInfo}
      this._projectPageData = pageData
      this._deadProjectPageData = deadPageData
    }
    if(data.org_participant){
      let pageData = {...data.org_participant.paginatorInfo}
      let deadPageData = {...data.deadDeals.paginatorInfo}
      this._projectPageData = pageData
      this._deadProjectPageData = deadPageData
    }
    if(data.sponsor_participant){
      let pageData = {...data.sponsor_participant.paginatorInfo}
      let deadPageData = {...data.deadDeals.paginatorInfo}
      this._projectPageData = pageData
      this._deadProjectPageData = deadPageData
    }
    if(data.sponsor_org_participants){
      let pageData = {...data.sponsor_org_participants.paginatorInfo}
      let deadPageData = {...data.deadSponsorDeals.paginatorInfo}
      this._sponsorProjectPageData = pageData
      this._deadSponsorProjectPageData = deadPageData
    }
    this.projectPageData.next(this._projectPageData)
    this.deadProjectPageData.next(this._deadProjectPageData)
    this.sponsorProjectPageData.next(this._sponsorProjectPageData)
    this.deadSponsorProjectPageData.next(this._deadSponsorProjectPageData)
  }

  private _setLoading(value:boolean){
    this._loading = value;
    this.loading.next(this._loading)
  }

  private _setSponsorLoading(value: boolean){
    this._sponsorTableLoading = value;
    this.sponsorTableLoading.next(this._sponsorTableLoading)
  }

  private _setOrganization(org: Organization){
    this._organization = org
    this.organization.next(this._organization)
    this._setFundInvestments(org?.ownershipInterests ?? [])
  }

  private _setFundInvestments(details:OwnershipInterest[]){
    let sortedDetails = [...details].sort((a,b) => {
      let nameA = a.ownedEntity?.fund?.name ?? ""
      let nameB = b.ownedEntity?.fund?.name ?? ""
      return nameA.localeCompare(nameB)
    })
    sortedDetails.forEach((detail:OwnershipInterest) => {
      if(detail.fundInvestor && detail.ownershipInterestDetail){
        for(let interest of detail?.ownershipInterestDetail){
          let investmentData: FundInvestment = {
            name: detail.ownedEntity?.fund?.name ?? null,
            fund_id: detail.ownedEntity?.fund?.id ?? null,
            fund_type: detail.ownedEntity?.fund?.fundType?.name ?? null,
            repeat: detail.fundInvestor?.is_repeat ?? false,
            amount: interest?.amount ?? 0,
            investment_class: interest?.investmentClass?.name ?? null,
            admitted_date: interest?.admission_date ?? null,
            exit_date: interest?.exit_date ?? null
          }
          this._fundInvestments.push(investmentData)
        }
      }
    })
    this.fundInvestments.next(this._fundInvestments)
  }

  private _setAssociatedDeals(dealParticipants: Participant[], isSponsorDeals?: boolean){
    this._associatedDeals = []
    this._deadDeals = []
    this._sponsorDeals = []
    this._deadSponsorDeals = []
    let sortedDealParticipants = [...dealParticipants].sort((a,b) => {
      const nameA = a.project?.name ?? "";
      const nameB = b.project?.name ?? ""
      return nameA.localeCompare(nameB)
    })
    sortedDealParticipants.forEach((deal: Participant) => {
      if(deal.project!==null){
        let isDeadDeal = deal.project?.projectStatuses?.find((status:any) => status.status?.name.toLowerCase() == 'dead' && status.active)
        let residentKey = deal.project?.projectAttributes?.find((att: ProjectAttribute) => att.attribute?.attributeType?.name.toLowerCase() == 'resident')
        let constructionKey = deal.project?.projectAttributes?.find((att: ProjectAttribute) => att.attribute?.attributeType?.name.toLowerCase() == 'construction')
        let cityState = deal.project?.properties?.[0]?.entity?.entityAddresses && deal.project?.properties?.[0]?.entity?.entityAddresses?.length > 0 ? deal.project?.properties?.[0]?.entity?.entityAddresses?.[0]?.address?.zipCode?.city + ", " +
          deal.project?.properties?.[0]?.entity?.entityAddresses?.[0]?.address?.zipCode?.state?.abbreviation : "-"
        let county = deal.project?.properties?.[0]?.entity?.entityAddresses?.[0]?.address?.zipCode?.county?.name
        let lihtcCredits = deal.project?.projectCredits?.filter((credit: ProjectCredit) => credit.taxCreditDesignation!==null)
        let ltModel = deal.project?.ltmodels?.filter((model:any) => model.active_model == true && model.kpiset!==null && model.kpiset?.kpiset_detail!==null)
        let dealData: ContactDealTable = {
          deal: deal.project?.name ?? "-",
          dealUrl: this.dataFormat.formatLink(deal.project),
          deal_type: deal.project?.projectType?.name ?? "-",
          role: deal.role ? deal.role.name : deal.roleString ? deal.roleString :  "-",
          organization: this._getSponsorOrganization(deal.project?.participants ?? [], this._sponsor)?.name ?? '-',
          organizationUrl: this._getSponsorOrganization(deal.project?.participants ?? [], this._sponsor) !== null ? this.dataFormat.formatLink(this._getSponsorOrganization(deal.project?.participants ?? [], this._sponsor)) : '',
          project_status: deal.project?.projectStatuses?.[0]?.status?.name ?? "-",
          closing_date: deal.project?.pipelineProjects?.[0]?.closingDate?.[0]?.date ?
            this.datePipe.transform(deal.project?.pipelineProjects?.[0]?.closingDate?.[0]?.date, 'MM/dd/yyy') ?? "-" :  "-",
          risk_rating: deal.project?.projectDetail?.risk_rating ?? "-",
          location: cityState,
          county: county ?? "-",
          tax_perc: lihtcCredits?.[0]?.taxCreditDesignation?.name ?? "-",
          lt_equity: this._setLTEquityString(deal.project?.projectCredits ?? []),
          lt_equity_value: this._setLTEquity(deal.project?.projectCredits ?? []),
          ppc: this._setPPCString(deal.project?.projectCredits ?? []),
          ppcValue: this._setPpc(deal.project?.projectCredits ?? []),
          lt_yield: ltModel?.[0]?.kpiset.kpiset_detail?.lower_tier_yield ?? 0,
          construction: constructionKey?.attribute?.name ?? "",
          resident: residentKey?.attribute?.name ?? "",
          total_units: deal.project?.properties?.[0]?.total_units ?? 0,
          total_lihtc: deal.project?.properties?.[0]?.total_lihtc_units ?? 0,
          hard_debt: deal.project?.projectDetail?.leverage ?? 0,
          outlets: this._setOutletsString(lihtcCredits?.[0]?.projectCreditOutlets ?? [])//lihtcCredits?.[0]?.projectCreditOutlets?.[0]?.fund?.name ?? "-"
        }
        if(!isDeadDeal && !isSponsorDeals) {
          this._associatedDeals.push(dealData)
          this.associatedDeals.next(this._associatedDeals)
        } else if(isDeadDeal && !isSponsorDeals){
          this._deadDeals.push(dealData)
          this.deadDeals.next(this._deadDeals)
          this._deadProjectPageData.total
        } else if(!isDeadDeal && isSponsorDeals){
          this._sponsorDeals.push(dealData)
          this.sponsorDeals.next(this._sponsorDeals)
        } else {
          this._deadSponsorDeals.push(dealData)
          this.deadSponsorDeals.next(this._deadSponsorDeals)
        }
      }
    })
  }


  private _setOutlets(dealParticipant: Participant[]){
    let sortedParticipants = [...dealParticipant].sort((a,b) => {
      let nameA = a.fund?.name ?? ""
      let nameB = b.fund?.name ?? ""
      return nameA.localeCompare(nameB)
    })
    sortedParticipants.forEach((participant: Participant) => {
      if(participant.fund!==null || participant.certificatedOutlet!==null){
        let outletData: ContactsOutletsTable = {
          name: participant?.fund?.name ?? "",
          fundUrl: participant?.fund !==null ? this.dataFormat.formatLink(participant?.fund) : participant?.certificatedOutlet!==null ?
          this.dataFormat.formatLink(participant.certificatedOutlet?.organization) : "",
          type: participant.certificatedOutlet!==null ? "Certificated" : "Fund",
          role: participant?.role?.name ?? ""
        }
        this._outlets.push(outletData)
      }
    })
    this.outlets.next(this._outlets)
  }

  private _setSponsorOrgs(orgs: Organization[]){
    let sortedOrgs = [...orgs].sort((a,b) => {
      let nameA = a.name ?? ""
      let nameB = b.name ?? ""
      return nameA.localeCompare(nameB)
    })
    this._sponsorOrgs = sortedOrgs
    this.sponsorOrgs.next(this._sponsorOrgs)
  }

  private _setOutletsString(outlets: ProjectCreditOutlet[]){
    let string = ""
    outlets.forEach((pco: ProjectCreditOutlet) => {
      if(string.length){
        string += ", "
      }
      string += pco?.fund?.name ?? ""
    })
    return string
  }


  private _getSponsorOrganization(participants: Participant[], sponsor: Sponsor | null){
    let organization:Organization | null = null;
    if(participants.length>0 && sponsor!==null){
      let sponsorParticipants:Participant[] = participants.filter((participant:Participant) => participant.organization!==null && participant.organization?.sponsor!==null && participant.organization?.sponsor?.name == sponsor.name)
      if(sponsorParticipants.length > 0){
        organization = sponsorParticipants?.[0].organization ?? null
      }
    }
    return organization
  }


  public getContacts(page: PageEvent, category:ContactCategory, letter: string,){
    let mutation:any = null
    if(category===ContactCategory.PEOPLE){
      mutation = get_people_contacts
    }
    if(category===ContactCategory.SPONSORS){
      mutation = get_sponsors
    }
    if(category===ContactCategory.ORGANIZATIONS){
      mutation = get_orgs_contacts
    }
    this.apollo.query({
      query:mutation,
      variables: {name: letter , page: page.pageIndex ?? 1},
      fetchPolicy: 'network-only'
    }).subscribe((response:any) => {
      this._people = response.data.getPeople?.data
      this.people.next(this._people)
      this._organizations = response.data.getOrganizations?.data
      this.organizations.next(this._organizations)
      this._sponsors = response.data.getSponsors?.data
      this.sponsors.next(this._sponsors)
      this._setListPagination(response.data)

    })
  }

  public getContact(category: ContactCategory, id: string | null, page: PageEvent){
    let mutation:any = null;
    if(category===ContactCategory.PEOPLE){
      mutation = get_person
    }
    if(category===ContactCategory.ORGANIZATIONS){
      mutation = get_organization
    }
    if(category===ContactCategory.SPONSORS){
      mutation = get_sponsor
    }
    this.apollo.query({
      query: mutation,
      variables: {
        id: id,
        page: page?.pageIndex ? page.pageIndex += 1 : 1
      }
    }).subscribe((response:any) => {
      this._person = response.data?.person;
      this.person.next(this._person)
      this._companyEvents = response.data?.company_event_attendees_by_person
      this.companyEvents.next(this._companyEvents)
      this._setOrganization(response.data?.organization)
      this._sponsor = response.data?.sponsor;
      this.sponsor.next(this._sponsor)
      this._setSponsorOrgs(response.data?.sponsor_orgs ?? [])
      this._setAssociatedDeals(category===ContactCategory.ORGANIZATIONS ? response.data?.org_participant.data : category===ContactCategory.PEOPLE ? response.data?.projects.data :
        category===ContactCategory.SPONSORS ? response.data.sponsor_participant.data : [])
      this._setAssociatedDeals(response.data?.deadDeals.data ?? [])
      let deals = this._setSponsorDealData(response.data.sponsor_org_participants ?? [], id)
      this._setAssociatedDeals(deals ?? [], true)
      let deadDeals = this._setSponsorDealData(response.data?.deadSponsorDeals ?? [], id)
      this._setAssociatedDeals(deadDeals ?? [], true)
      this._totals = response.data?.totals
      this.totals.next(this._totals)
      this._deadTotals = response.data?.deadTotals
      this.deadTotals.next(this._deadTotals)
      this._setOutlets(category===ContactCategory.PEOPLE ? response.data?.outlets : [])
      this._setProjectTablePagination(response.data)
      let combinedOrgsDetails:OwnershipInterest[] = []
      let sponsorOrgs = response.data.sponsor_orgs ?? []
      if(sponsorOrgs.length){
        sponsorOrgs.forEach((org:Organization) => {
          combinedOrgsDetails.push(...org?.ownershipInterests ?? [])
        })
        this._setFundInvestments(combinedOrgsDetails)
      }
      this._setLoading(false)
    })
  }

  public getSponsorAssociatedDeals(id: string | null, page: PageEvent){
    this._setSponsorLoading(true)
    this.apollo.query({
      query: get_sponsor_organization_deals,
      variables: {
        id: id,
        page: page?.pageIndex ? page.pageIndex += 1 : 1
      }
    }).subscribe((response:any) => {
      let deals = this._setSponsorDealData(response.data.sponsor_org_participants.data ?? [], id)
      this._setAssociatedDeals(deals ?? [], true)
      let deadDeals = this._setSponsorDealData(response.data?.deadSponsorDeals.data ?? [], id)
      this._setAssociatedDeals(deadDeals ?? [], true)
      this._sponsorOrgTotals = response.data.totals
      this.sponsorOrgTotals.next(this._sponsorOrgTotals)
      this._deadOrgTotals = response.data.deadTotals
      this.deadOrgTotals.next(this._deadOrgTotals)
      this._setProjectTablePagination(response.data)
      this._setSponsorLoading(false)
    })
  }

  public getPage(event: PageEvent, letter: string, category: ContactCategory){
    this.getContacts(event, category, letter)
  }

  private _setSponsorDealData(projects:Project[], id: string | null){
    let listData:any = []
    projects.forEach((proj: Project) => {
      let roleString = ""
      proj.participants?.forEach((par: Participant) => {
        if(par.organization?.sponsor?.id==id){
          if(roleString.length){
            roleString += ", "
          }
          roleString += par.role.name
        }
      })
      let obj = {
        project: proj,
        role: {
          name: roleString
        }
      }
      listData.push(obj)
    })
    return listData
  }

  private _setPPCString(projectCredits: ProjectCredit[]){
    let ppcString = "";
    projectCredits.forEach((credit: ProjectCredit) => {
      if(credit.crea_syndicated){
        if(ppcString.length!==0){
          ppcString += "\n"
        }
        ppcString += credit?.taxCreditType?.level + " " + credit?.taxCreditType?.name
        if(credit?.taxCreditDesignation!==null){
          ppcString = ppcString + " " + credit?.taxCreditDesignation?.name
        }
        ppcString = ppcString + " - " + this.currencyPipe.transform(credit.price, 'USD', 'symbol', '1.4-4')

      }
    })
    return ppcString
  }

  private _setPpc(projectCredits: ProjectCredit[]){
    let values:number[] = []
    projectCredits.forEach((ppc:ProjectCredit) => {
        if(ppc?.price && ppc.crea_syndicated){
          values.push(ppc.price)
        }
    })
    return values
  }

  private _setLTEquityString(projectCredits: ProjectCredit[]){
    let ltEquityString = ""
    projectCredits.forEach((credit: ProjectCredit) => {
      if(credit.crea_syndicated){
        if(ltEquityString.length!==0){
          ltEquityString += "\n"
        }
        ltEquityString += credit.taxCreditType?.level + " " + credit.taxCreditType?.name
        if(credit.taxCreditDesignation!==null){
          ltEquityString = ltEquityString + " " + credit.taxCreditDesignation?.name
        }
        ltEquityString = ltEquityString + " - " + this.currencyPipe.transform(credit.equity_amount, 'USD', 'symbol', '1.0-0')
      }
    })
    return ltEquityString
  }

  private _setLTEquity(projectCredits: ProjectCredit[]){
    let values:number[] = []
    projectCredits.forEach((ppc:ProjectCredit) => {
      if(ppc.crea_syndicated){
        values.push(ppc.equity_amount)
      }
    })
    return values
  }
}
